
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://oaffvrdgtpfqvmplktwd.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9hZmZ2cmRndHBmcXZtcGxrdHdkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg2MDYwODQsImV4cCI6MjA2NDE4MjA4NH0.zGUq6nyIUnZY8k1i1kfADxripwGRHJXIo7OnNg7fYao';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Missing Supabase environment variables. Some features may not work correctly.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    autoRefreshToken: true,
    persistSession: true,
  },
})
